/* import __COLOCATED_TEMPLATE__ from './card-list.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './card-list.module.scss';

@classic
export default class SiteBillingCardList extends Component {
  styles = styles;
}
